import './App.css';
import 'antd/dist/antd.min.css';
import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import CollaborationsPage from './routes/Collaborations/Collaborations';
import CommunicationPage from './routes/Communication/Communication';
import ContributionPage from './routes/Contributions/Contribution';
import EducationPage from './routes/Education/Education';
import EngineeringPage from './routes/Engineering/Engineering';
import EntrepreneurshipPage from './routes/Entrepreneurship/Entrepreneurship';
import HumanPracticesPage from './routes/HumanPractices/HumanPractices';
import ImplementationPage from './routes/Implementation/Implementation';
import ModelPage from './routes/Model/Model';
import OverviewPage from './routes/Overview/Overview';
import PartnershipPage from './routes/Partnership/Partnership';
import ProofOfConceptPage from './routes/ProofOfConcept/ProofOfConcept';
import ReferencesPage from './routes/References/References';
import SafetyPage from './routes/Safety/Safety';
import TeamPage from './routes/Team/Team';
import HomePage from './routes/Home/Home';
import HeadMenuComp from './components/HeadMenu/HeadMenuComp';
import WetLabPage from './routes/WetLabX/WetLab';
import ProblemPage from './routes/ProblemX/Problem';
import MedalCPage from './routes/MedalCriteriaX/MedalCriteria';
import PDescriptionPage from './routes/Contributions/PDescription';

// ::-webkit-scrollbar {display: none;}
/**
 * Basic App function for routing
 * @return {App}
 */
function App() {
  return (
    <div className='app'>
      <div className='font-face-k'>
        <BrowserRouter>
          <Routes>
            <Route exact path="/tecccm" element={<HeadMenuComp/>}>
              <Route index element={<HomePage/>}/>
              <Route exact path='/tecccm/home' element={<HomePage/>}/>
              <Route exact path='/tecccm/attributions' element={<TeamPage/>}/>
              <Route exact path='/tecccm/collaborations' element={<CollaborationsPage/>}/>
              <Route exact path='/tecccm/communication' element={<CommunicationPage/>}/>
              <Route exact path='/tecccm/contributions' element={<ContributionPage/>}/>
              <Route exact path='/tecccm/description' element={<PDescriptionPage/>}/>
              <Route exact path='/tecccm/education' element={<EducationPage/>}/>
              <Route exact path='/tecccm/engineering' element={<EngineeringPage/>}/>
              <Route exact path='/tecccm/entrepreneurship' element={<EntrepreneurshipPage/>}/>
              <Route exact path='/tecccm/human-practices' element={<HumanPracticesPage/>}/>
              <Route exact path='/tecccm/implementation' element={<ImplementationPage/>}/>
              <Route exact path='/tecccm/model' element={<ModelPage/>}/>
              <Route exact path='/tecccm/overview' element={<OverviewPage/>}/>
              <Route exact path='/tecccm/partnership' element={<PartnershipPage/>}/>
              <Route exact path='/tecccm/proof-of-concept' element={<ProofOfConceptPage/>}/>
              <Route exact path='/tecccm/references' element={<ReferencesPage/>}/>
              <Route exact path='/tecccm/safety' element={<SafetyPage/>}/>
              <Route exact path='/tecccm/wet-lab' element={<WetLabPage/>}/>
              <Route exact path='/tecccm/problem' element={<ProblemPage/>}/>
              <Route exact path='/tecccm/criteria' element={<MedalCPage/>}/>
              <Route exact path='/tecccm/contribution' element={<ContributionPage/>}/>
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
